import { useLayoutEffect } from 'react';
import { hasRouteLcpShell, removeRouteLcpShell, removeSeoCrawl } from '@/lib/staticHero';

/** True when build-time crawl HTML is present (pre-hydration). */
export function hasSeoCrawlShell(): boolean {
  return document.getElementById('seo-crawl') != null;
}

/** True when any build-time prerender shell is still in the DOM (crawl and/or LCP hero). */
export function hasPrerenderShell(): boolean {
  return hasSeoCrawlShell() || hasRouteLcpShell();
}

export function seoCrawlArtifact(): string | null {
  return document.getElementById('seo-crawl')?.getAttribute('data-seo-artifact') ?? null;
}

/**
 * Remove `#seo-crawl` / `#route-lcp-shell` after React has painted equivalent route content.
 * Call with `ready=true` when listings / detail / hub grid is in the DOM (not while spinners show).
 *
 * ShellLayout removes the green LCP banner as soon as the navbar mounts. Pages should show
 * normal loading skeletons (not `return null`) so the main area never goes blank under chrome.
 */
export function useSeoCrawlWhenReady(ready: boolean) {
  useLayoutEffect(() => {
    if (!ready || !hasPrerenderShell()) return;
    const frame = requestAnimationFrame(() => {
      removeRouteLcpShell();
      removeSeoCrawl();
    });
    return () => cancelAnimationFrame(frame);
  }, [ready]);
}
